import {
  ComponentRef,
  ComponentFactory,
  ComponentFactoryResolver,
  Injector,
  ViewContainerRef,
  ReflectiveInjector,
  ResolvedReflectiveProvider
} from '@angular/core';

export interface CreateComponentArgs {
  component: any;
  vcRef: ViewContainerRef;
  injector?: Injector;
  bindings?: ResolvedReflectiveProvider[];
  projectableNodes?: any[][];
}
/**
 * @param {?} instructions
 * @return {?}
 */
export function createComponent(instructions: CreateComponentArgs): ComponentRef<any> {
  const /** @type {?} */ injector: Injector = getInjector(instructions);
  const /** @type {?} */ cmpFactory: ComponentFactory<any>
    = injector.get(ComponentFactoryResolver).resolveComponentFactory(instructions.component);

  if (instructions.vcRef) {
    return instructions.vcRef.createComponent(
      cmpFactory,
      instructions.vcRef.length,
      injector,
      instructions.projectableNodes
    );
  } else {
    return cmpFactory.create(injector);
  }
}
/**
 * @param {?} instructions
 * @return {?}
 */
function getInjector(instructions: CreateComponentArgs) {
  const /** @type {?} */ ctxInjector = instructions.injector || instructions.vcRef.parentInjector;
  return Array.isArray(instructions.bindings) && instructions.bindings.length > 0 ?
    ReflectiveInjector.fromResolvedProviders(instructions.bindings, ctxInjector) : ctxInjector;

}

